export const isVehicleValuationValid = (validUntil: string, now: Date = new Date()): boolean => {
  return new Date(validUntil).getTime() > now.getTime();
};
